import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import setupAxiosInterceptors from "../util/setupAxiosInterceptors";

const SetupInterceptors = () => {
    const { setAuth } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        setupAxiosInterceptors(setAuth, navigate);
    }, [setAuth, navigate]);

    return null; // This component doesn't render anything
};

export default SetupInterceptors;
